import React, { createContext, useContext } from 'react';
import { Session, ParticipationStatus, FilterType } from '@app/api';
import { FilterData } from '../../components/Filter';

export interface ParticipationTableContextType {
  session: Session;
  sessionHaveDeviceQuota: boolean | undefined;
  tab: string | number;
  sorting: {
    sort?: { field: string; type: string; direction: 'asc' | 'desc' };
    handleSortClick: (field: string, type: string) => void;
  };
  filtering: {
    getFieldCurrentFilter: (field: string) => FilterData | undefined;
    handleFilterChange: (
      field: string,
      type: FilterType,
      values: string[],
      min?: number | Date,
      max?: number | Date,
    ) => void;
  };
  special: {
    status?: {
      fieldKey: string;
      fieldValues: any[];
      statusList: ParticipationStatus[];
      haveDeclinedReason: boolean;
    };
    rendering?: {
      idsToHighlight: string[];
    };
  };
}

const ParticipationTableContext =
  createContext<ParticipationTableContextType | null>(null);

export const ParticipationTableProvider = ({
  children,
  value,
}: {
  children: React.ReactNode;
  value: ParticipationTableContextType;
}) => {
  return (
    <ParticipationTableContext.Provider value={value}>
      {children}
    </ParticipationTableContext.Provider>
  );
};

export const useParticipationTableContext = () => {
  const context = useContext(ParticipationTableContext);
  if (!context) {
    throw new Error(
      'useParticipationTableContext must be used within a ParticipationTableProvider',
    );
  }
  return context;
};
